import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddCompetition = () => {
    const navigate = useNavigate();
    const [compi, setCompi] = useState({
        mcName: null,
        mcSubtitle: null,
        mcDesc: null,
        mcGenre: null,
        mcCities: null,
        rules: null,
        prizesLyp: null,
        isTeamCompi: null,
        minParticipants: null,
        maxParticipants: null,
    });

    const [disabled, setDisabled] = useState(false);
    const [genres, setGenres] = useState([]);
    const [cities, setCities] = useState([]);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const onChange = (e) => {
        setCompi({ ...compi, [e.target.name]: e.target.value });
    };

    const getAllCities = () => {
        Axios.get("https://ashish.moodi.org/multicity/get_mul_cities")
            .then((res) => setCities(res.data))
            .catch((err) => console.error(err));
    };

    const getAllGenres = () => {
        Axios.get("https://ashish.moodi.org/multicity/get_mul_genres")
            .then((res) => setGenres(res.data))
            .catch((err) => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (compi.isTeamCompi) {
            compi.maxParticipants = parseInt(compi.maxParticipants);
            compi.minParticipants = parseInt(compi.minParticipants);
        }
        let selectedCities = compi.mcCities;
        selectedCities.forEach((element) => {
            Axios.post(
                "https://ashish.moodi.org/multicity/add_mul_compi",
                {
                    mcName: compi.mcName,
                    mcSubtitle: compi.mcSubtitle,
                    mcDesc: compi.mcDesc,
                    mcGenre: compi.mcGenre,
                    mcCityId: element,
                    rules: compi.rules,
                    prizesLyp: compi.prizesLyp,
                    isTeamCompi: compi.isTeamCompi,
                    minParticipants: compi.minParticipants,
                    maxParticipants: compi.maxParticipants,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
                .then((res) => {
                    console.log(res.data);
                    if (res.data.status == "done") {
                        console.log(
                            `Competition added to ${element} successfully`
                        );
                        alert("competition added successfully");
                        setCompi(null);
                        setSubmitDisabled(false);
                    }
                })
                .catch((err) => console.error(err));
        });
    };

    const onCityChange = (e) => {
        var options = e.target.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        compi.mcCities = value;
    };

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            getAllGenres();
            getAllCities();
        } else {
            navigate("/admin/login");
        }
    }, []);

    return (
        <div className="container-fluid">
            <form>
                <div className="my-3">
                    <div className="row">
                        <div className="col-3">
                            <label htmlFor="mcName" className="form-label">
                                Competition Name
                            </label>
                        </div>
                        <div className="col-9">
                            <input
                                type="text"
                                className="form-control"
                                id="mcName"
                                name="mcName"
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-3">
                        <label htmlFor="mcSubtitle" className="form-label">
                            Subtitle
                        </label>
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            id="mcSubtitle"
                            name="mcSubtitle"
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-3">
                        <label htmlFor="mcDesc" className="form-label">
                            Description
                        </label>
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            id="mcDesc"
                            name="mcDesc"
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-3">
                        <label htmlFor="mcGenre" className="form-label">
                            Genre
                        </label>
                    </div>
                    <div className="col-4">
                        <select
                            name="mcGenre"
                            id="mcGenre"
                            placeholder="Select One value"
                            value={compi.mcGenre}
                            onChange={onChange}
                            required
                        >
                            <option value="" selected>
                                Please select a value
                            </option>
                            {genres.map((genre) => {
                                return (
                                    <option value={genre.mcgId}>
                                        {genre.mcgName}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="col-3">
                        <label htmlFor="mcCityId" className="form-label">
                            Cities (Select all that apply by holding CMD(on mac)
                            or CTRL(on windows))
                        </label>
                    </div>
                    <div className="col-2">
                        <select
                            name="mcCityId"
                            id="mcCityId"
                            placeholder="Select One value"
                            onChange={onCityChange}
                            multiple
                        >
                            {cities.map((city) => {
                                return (
                                    <option value={city.mcCityId}>
                                        {city.mcCityName}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="mb-3 form-check col-3 mx-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="isTeamCompi"
                            name="isTeamCompi"
                            onChange={(e) => {
                                setDisabled(e.target.checked);
                                setCompi({
                                    ...compi,
                                    [e.target.name]: e.target.checked,
                                });
                            }}
                            checked={disabled}
                            required={disabled}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="isTeamCompi"
                        >
                            Team Compi
                        </label>
                    </div>
                    <div className="mb-3 col-2">
                        <label htmlFor="minParticipants">
                            Min Participants
                        </label>
                    </div>
                    <div className="mb-3 col-1">
                        <input
                            disabled={!disabled}
                            type="number"
                            className="form-control"
                            id="minParticipants"
                            name="minParticipants"
                            onChange={onChange}
                            required={disabled}
                            placeholder="0"
                        />
                    </div>
                    <div className="mb-3 col-2">
                        <label htmlFor="maxParticipants">
                            Max Participants
                        </label>
                    </div>
                    <div className="mb-3 col-1">
                        <input
                            disabled={!disabled}
                            type="number"
                            className="form-control"
                            id="maxParticipants"
                            name="maxParticipants"
                            onChange={onChange}
                            required={disabled}
                            placeholder="0"
                        />
                    </div>
                </div>
                <div className="form-floating mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Leave a comment here"
                        id="rules"
                        name="rules"
                        style={{ height: "15vh" }}
                        onChange={onChange}
                    ></textarea>
                    <label htmlFor="rules">Rules</label>
                </div>
                <div className="form-floating mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Leave a comment here"
                        id="prizesLyp"
                        name="prizesLyp"
                        style={{ height: "15vh" }}
                        onChange={onChange}
                    ></textarea>
                    <label htmlFor="prizesLyp">Prizes & LYP</label>
                </div>
                <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={submitDisabled}
                >
                    Submit
                </button>
            </form>
        </div>
    );
};

export default AddCompetition;
